import React from 'react';
import PropTypes from 'prop-types';
import Banner from './Banner';

export const VACCINE_HEADER =
    'Learn more about COVID-19 vaccination appointments';

const VaccineBanner = (props) => {
    const trackingData = {
        type: 'TRACK_VACCINE_BANNER_CLICK_APPOINTMENT',
        meta: {
            analytics: {
                action: 'COVIDVaccineBannerClickAppointment',
                category: props.category,
            },
        },
    };

    const trackingData_2 = {
        type: 'TRACK_VACCINE_BANNER_CLICK_HEALTHCARE_DEPARTMENTS',
        meta: {
            analytics: {
                action: 'COVIDVaccineBannerClickHealthcareDepartment',
                category: props.category,
            },
        },
    };

    const destinationURL =
        'https://www.eventbrite.com/blog/how-to-register-for-events-with-time-slots/';

    const destinationURL_2 =
        'https://www.eventbrite.com/blog/how-to-create-covid-vaccine-appointments-eventbrite/';

    return (
        <Banner leftAccentColor="#F05537" style="dark" header={VACCINE_HEADER}>
            <span>
                For information on how to sign up for a COVID-19 vaccination
                appointment or time slot,{' '}
                <a
                    onClick={() => {
                        props.handleTracking(trackingData);
                    }}
                    rel="noopener noreferrer"
                    target="_blank"
                    href={destinationURL}
                >
                    click here
                </a>
                {'. '}
                Healthcare departments and organizations, learn how to manage
                registrations{' '}
                <a
                    onClick={() => {
                        props.handleTracking(trackingData_2);
                    }}
                    rel="noopener noreferrer"
                    target="_blank"
                    href={destinationURL_2}
                >
                    here
                </a>
                .
            </span>
        </Banner>
    );
};

VaccineBanner.propTypes = {
    handleTracking: PropTypes.func,
    trackingParams: PropTypes.string,
    category: PropTypes.string,
};

export default VaccineBanner;
